import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoMdAdd } from "react-icons/io";
import { Pagination } from "antd";
import { useNavigate, Route, Routes } from "react-router-dom";
import AdminForm from "./AdminForm";
import AdminListItem from "./AdminListItem";
import { NotAdminPlaceHoldersvg, AdminsIcon } from "../../../assets/icons";
import ZoneIcon from "../.../../../../assets/Zone.svg";
import { SearchBar, Button, Spinner } from "../../../UI";
import { getAllzones } from "../../../store/actions";
import Container from "./styles";
import Place from "./Places";

const Zones = () => {
  const [loading, setLoading] = useState(false);
  const [searchVal, setSearch] = useState("");
  const {zoneData} = useSelector((s) => s)
  const [adminLists, setAdminLists] = useState(() => zoneData.zoneData);

  const dispatch = useDispatch();
  const navigate = useNavigate();
 
  useEffect(() => {
    dispatch(getAllzones());
  }, [dispatch]);

  useEffect(() => {
    if (zoneData && zoneData.zoneData && searchVal === "") {
      setAdminLists(zoneData.zoneData);
    }
  }, [searchVal, zoneData]);

  const handleSearch = () => {
    setLoading(true);
    dispatch(getAllzones(searchVal))
      .then((response) => {
        console.log(response, "resp")
        if (response.data) {
          setAdminLists(response);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Container>
      <Routes>
        <Route path=":action" element={<AdminForm />} />
        <Route path="/" element={
          <>
            <header>
              <div className="top--row">
                <h2>
                  Zones
                  </h2>
                <img src={ZoneIcon} style={{ marginLeft: 20 }} />
              </div>
              <div className="header--row">
                <SearchBar
                  placeholder="Search by names"
                  handleSearch={handleSearch}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />
                <Button
                  className="add--btn"
                  onClick={() => navigate("/dashboard/zone/add")}
                >
                  <IoMdAdd />
                  Add Zone
                </Button>
              </div>
            </header>
            <div className="admin--content__containers">
              {loading ? (
                <div className="loading-container">
                  <Spinner size={"70px"} />
                  <p>
                    Searching for{" "}
                    <span className="u--color__primary">{searchVal}</span>
                  </p>
                </div>
              ) : (
                <>
                  <div className="admin--lists--containers">
                    {adminLists && adminLists.data && adminLists.data.zones && adminLists.data.zones.length > 0 ? (
                      adminLists.data.zones.map((item, id) => <Place key={item.id || id} item={item} id={id} />)
                    ) : null}
                  </div>
                  {adminLists && adminLists.data && (!adminLists.data.zones || adminLists.data.zones.length === 0) && (
                    <div className="noAdminList--container">
                      <NotAdminPlaceHoldersvg />
                      <h3>No zone added yet</h3>
                      <p className="instruction">
                        Add as many zones as you want to manage delivery areas.
                      </p>
                      <Button
                        onClick={() => navigate("/dashboard/zone/add")}
                      >
                        <IoMdAdd />
                        Add Zone
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          </>
        } />
      </Routes>
    </Container>
  );
};

export default Zones;
